module.exports = __webpack_public_path__ + "ek4gzZ-GeXAPcSbHtCeQI_esZW2xOQ-xsNqO47m55DA.b4b5f48bf82325bfe1d4.woff2";


//////////////////
// WEBPACK FOOTER
// D:/OficinaVirtual/FrontEndFinamco/EFactoringManager/src/assets/fonts/roboto/ek4gzZ-GeXAPcSbHtCeQI_esZW2xOQ-xsNqO47m55DA.woff2
// module id = ../../../../../src/assets/fonts/roboto/ek4gzZ-GeXAPcSbHtCeQI_esZW2xOQ-xsNqO47m55DA.woff2
// module chunks = styles